// extracted by mini-css-extract-plugin
export var cardIcon = "_5n-4";
export var checkboxCard = "_5n-0";
export var checkboxCardSelected = "_5n-3";
export var disabled = "_5n-1";
export var outerBorder = "_5n-2";
export var spacerMedium = "_5n-7";
export var spacerSmall = "_5n-6";
export var spacerXsmall = "_5n-5";